var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxEmailSnow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_228_1352",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 42,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H5V42H47V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_228_1352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.693 23.6428C43.0187 23.4393 43.4805 23.6587 43.4805 24.0429V33.2853C43.4805 36.1728 41.1355 38.5003 38.2305 38.5003H13.748C10.843 38.5003 8.49805 36.1728 8.49805 33.2853V24.0509C8.49805 23.6689 8.97385 23.4491 9.30305 23.6428L22.4105 31.4478C23.513 32.0953 24.7555 32.4278 25.998 32.4278C27.2405 32.4278 28.483 32.0953 29.5855 31.4478L42.693 23.6428Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4999 19.1799C43.4999 19.1799 43.4999 19.3374 43.4824 19.4074L43.4999 19.1799Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5205 14.3676L29.2705 4.6376C27.3455 3.1151 24.6505 3.1151 22.7255 4.6376L10.4755 14.3676C9.21555 15.3651 8.49805 16.8526 8.49805 18.4276V19.1801C8.49805 20.3876 9.14555 21.5251 10.1955 22.1376L23.303 29.9426C24.9655 30.9226 27.0305 30.9226 28.693 29.9426L41.8005 22.1376C42.7805 21.5601 43.4105 20.5276 43.4805 19.4076V18.4276C43.4805 16.8526 42.763 15.3651 41.5205 14.3676Z",
    fill: "#34D399"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxEmailSnow);
export default __webpack_public_path__ + "static/media/iconsax-email-snow.40e2fd533bf5c91bc273b2275947b4e6.svg";
export { ForwardRef as ReactComponent };